// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"6d0be34e","727":"17243ce6"}[chunkId] + ".chunk.css";
};